<script lang="ts">
type Props = {
  current: number;
  total: number;
  showText?: boolean;
  animated?: boolean;
  text?: string;
};

let {
  current = 0,
  total = 100,
  showText = true,
  animated = true,
  text
}: Props = $props();

let progressPercentage = $derived(
  total > 0 ? Math.min((current / total) * 100, 100) : 0
);

let defaultText = $derived(`Processing ${current} of ${total}...`);
let displayText = $derived(text ?? defaultText);
</script>

<div class="progress-bar-container">
  <div class="progress-bar">
    <div
      class="progress-fill"
      class:animated
      style="width: {progressPercentage}%"
    ></div>
  </div>
  {#if showText}
    <p class="progress-text">{displayText}</p>
  {/if}
</div>

<style lang="scss">
.progress-bar-container {
  padding: var(--spacing-md);
  background: var(--color-background);
  border: var(--border-width-thin) solid var(--color-border);
  border-radius: var(--radius-md);
}

.progress-bar {
  height: var(--progress-bar-height);
  background: var(--color-background-secondary);
  border-radius: var(--radius-sm);
  overflow: hidden;
  margin-bottom: var(--spacing-sm);
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--color-primary), var(--color-primary-hover));
  transition: width 0.3s ease;

  &.animated {
    animation: shimmer 2s infinite;
  }
}

@keyframes shimmer {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}

.progress-text {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  text-align: center;
}
</style>
